import React from 'react';
import KidoProject from '../../assets/images/new-logo.png';
import { Link } from 'react-router-dom';

const MasterPublicLayout = ({ children }) => {
    return (
        <>
            <div className='bg-white p-6 mb-6'>
                <Link to="/" className="d-inline-block">
                    <img src={KidoProject} alt="" />
                </Link>
            </div>
            {children}
        </>
    )
}

export default MasterPublicLayout